import * as Types from '../../../types/bff/gql-schema';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { gqlFetcher } from '@/utils/fetcher';

export const NonF2fMedicalCategoriesDocument = `
    query NonF2fMedicalCategories($size: Int) {
  nonF2fMedicalCategories(size: $size) {
    category
    id
    name
    iconUrl
  }
}
    `;
export const useNonF2fMedicalCategoriesQuery = <
      TData = Types.NonF2fMedicalCategoriesQuery,
      TError = Types.GraphqlError
    >(
      variables?: Types.NonF2fMedicalCategoriesQueryVariables,
      options?: UseQueryOptions<Types.NonF2fMedicalCategoriesQuery, TError, TData>,
    ) =>
    useQuery<Types.NonF2fMedicalCategoriesQuery, TError, TData>(
      variables === undefined ? ['NonF2fMedicalCategories'] : ['NonF2fMedicalCategories', variables],
      gqlFetcher<Types.NonF2fMedicalCategoriesQuery, Types.NonF2fMedicalCategoriesQueryVariables>(NonF2fMedicalCategoriesDocument, 'NonF2fMedicalCategories', variables),
      options
    );

useNonF2fMedicalCategoriesQuery.getKey = (variables?: Types.NonF2fMedicalCategoriesQueryVariables) => variables === undefined ? ['NonF2fMedicalCategories'] : ['NonF2fMedicalCategories', variables];
;

useNonF2fMedicalCategoriesQuery.fetcher = (variables?: Types.NonF2fMedicalCategoriesQueryVariables, options?: RequestInit['headers']) => gqlFetcher<Types.NonF2fMedicalCategoriesQuery, Types.NonF2fMedicalCategoriesQueryVariables>(NonF2fMedicalCategoriesDocument, 'NonF2fMedicalCategories', variables, options);